import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IScheduledDowngradeBannerSlice {
  scheduledDowngradeBannerDisabled: boolean;
}

export const createScheduledDowngradeBannerSliceDefaultValues = (): IScheduledDowngradeBannerSlice => ({
  scheduledDowngradeBannerDisabled: false,
});

export const createScheduledDowngradeBannerSlice: StateCreator<IScheduledDowngradeBannerSlice> = () =>
  createScheduledDowngradeBannerSliceDefaultValues();

export type ScheduledDowngradeBannerPageStore = UseBoundStore<StoreApi<IScheduledDowngradeBannerSlice>>;

export const createScheduledDowngradeBannerHooks = (pageStore: ScheduledDowngradeBannerPageStore) => {
  return {
    useDisabled: () => pageStore((state) => state.scheduledDowngradeBannerDisabled),
  };
};

export type ScheduledDowngradeBannerHooks = ReturnType<typeof createScheduledDowngradeBannerHooks>;
